"use client";

import { getProfiles } from "@lib/auth/jwt";
import { NextPage } from "next";
import { useRouter } from "next/navigation";

const UserProfilePage: NextPage = ({}) => {
  const router = useRouter();
  if (!global.window) return null;

  const userLoggedIn = !!getProfiles().user;
  if (userLoggedIn) router.replace(`/${window.siteId}/user/profile_home`);
  else router.replace(`/${window.siteId}/user/login`);

  return <></>;
};

export default UserProfilePage;
